import {Component, Input} from '@angular/core';
import {DcpResourceData} from '@app/model/dcp-resource-data';

@Component({
  selector: 'dcp-product-resource-tile',
  templateUrl: './product-resource-tile.component.html',
  styleUrls: ['./product-resource-tile.component.scss']
})
export class ProductResourceTileComponent {

  @Input() resource: DcpResourceData;


  get hasImage(): boolean {
    return !!this.resource && !!this.resource.source;
  }
}
